import React, { useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getBadge, addBadge, updateBadge, clearCurrentBadge } from '../actions/badgeActions';
import BadgeForm from '../components/badges/BadgeForm';
import AdminLayout from '../components/settings/AdminLayout';

import { isAdminRole } from '../utils/roleHelpers';

const BadgeEditor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { currentBadge, badgeLoading } = useSelector(state => state.badge);
  const { user } = useSelector(state => state.auth);

  const isViewMode = location.pathname.includes('/view');
  const isEditMode = location.pathname.includes('/edit');
  const isAdmin = isAdminRole(user?.role);

  useEffect(() => {
    if (id) dispatch(getBadge(id));
    return () => { dispatch(clearCurrentBadge()); };
  }, [dispatch, id]);

  const handleSubmit = async (badgeData) => {
    try {
      if (id) {
        await dispatch(updateBadge(id, badgeData));
      } else {
        await dispatch(addBadge(badgeData));
      }
      navigate('/settings', { state: { activeTab: 'Badges' } });
    } catch (error) {
      console.error('Error saving badge:', error);
    }
  };

  const handleClose = () => navigate('/settings', { state: { activeTab: 'Badges' } });

  if (badgeLoading && id) {
    return (
      <AdminLayout activeTab="Badges">
        <div className="max-w-4xl mx-auto space-y-6">
          <div className="h-8 w-48 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-32 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-10 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </AdminLayout>
    );
  }

  if (id && !currentBadge && !badgeLoading) {
    return (
      <AdminLayout activeTab="Badges">
        <div className="flex flex-col items-center justify-center py-12">
          <div className="text-red-500 text-xl mb-4">Badge not found</div>
          <button onClick={handleClose} className="px-4 py-2 bg-[#1086a4] text-white rounded-lg hover:bg-[#054581] transition-colors">
            Return to Badges
          </button>
        </div>
      </AdminLayout>
    );
  }

  const mode = isViewMode ? 'view' : isEditMode ? 'edit' : 'new';

  return (
    <AdminLayout activeTab="Badges">
      <BadgeForm badge={currentBadge} mode={mode} onSubmit={handleSubmit} onClose={handleClose} />
    </AdminLayout>
  );
};

export default BadgeEditor;
